import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export const BRILLO_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_c9fea976-40f2-4dce-bdbf-cc7b62ee9cc5/artifacts/x27o7ld5_Brillo%20Finance%20Inverted%20Color-3.png";

export const WHATSAPP_NUMBER = "523344065965";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hola Brillo Finance, quiero información sobre crédito hipotecario."
)}`;

export const CREDITARIA_URL =
  "https://preca.creditaria.app/?utm_id=e1d27474-1ff6-4053-904f-91789aecdcd2";

export const TIPO_CREDITO_OPTIONS = [
  { value: "adquisicion", label: "Adquisición" },
  { value: "construccion", label: "Construcción" },
  { value: "sustitucion", label: "Sustitución de hipoteca" },
  { value: "liquidez", label: "Liquidez" },
];

export const INGRESOS_OPTIONS = [
  { value: "empleado", label: "Empleado" },
  { value: "negocio_propio", label: "Negocio propio" },
  { value: "informal", label: "Informal" },
  { value: "sin_comprobar", label: "Sin comprobar" },
];

export const labelOf = (opts, val) =>
  opts.find((o) => o.value === val)?.label || val;
